import Cookies from 'js-cookie';

export function hasPrivilegePermission(
  feature: string,
  permission?: string
): boolean {
  const privilegesStr = localStorage.getItem("USER_PRIVILEGES");
  const planId = Cookies.get("PLANID");

  if (!privilegesStr) return false;

  let userPrivileges: Array<Record<string, string[]>> = [];

  try {
    userPrivileges = JSON.parse(privilegesStr);
  } catch (e) {
    console.error("Invalid USER_PRIVILEGES format", e);
    return false;
  }

  const isNormalUser = !planId || planId === 'undefined';

  if (isNormalUser) {
    // Allow everything for normal users, or change logic if needed
    return true;
  }

  // Find privilege by feature/module name
  const privilegeEntry = userPrivileges.find(p => Object.prototype.hasOwnProperty.call(p, feature));

  if (!privilegeEntry) {
    return false; // Feature not found
  }

  // If no specific permission is requested, feature exists — return true
  if (!permission) {
    return true;
  }

  const allowedPermissions = privilegeEntry[feature];
  return allowedPermissions.includes(permission);
}
